import jwtDecode from 'jwt-decode';
import { LOCATION_CHANGE } from 'react-router-redux';
import { combineActions, handleActions } from 'redux-actions';
import { REHYDRATE } from 'redux-persist';
import { hasTokenExpired } from '../../../common';
import { routes } from '../../../constants';
import actions from './actions';

export const initialState = {
  isFetching: false,
  error: null,
  user: null,
  idToken: null,
  attributes: null
};

const reducers = {
  [combineActions(actions.session.login,
    actions.session.submitNewPassword)]: (state) => ({
      ...state,
      isFetching: true
    }),
  [combineActions(actions.session.loginSuccess,
    actions.session.newPasswordRequired)]: (state, { payload }) => ({
      ...state,
      isFetching: false,
      error: null,
      ...payload
    }),
  [actions.session.loginFailed]: (state, { payload: { error } }) => ({
    ...state,
    isFetching: false,
    error
  }),
  [actions.session.removeIdToken]: (state) => ({
    ...state,
    idToken: null
  }),
  [REHYDRATE]: (state, { payload: { session: { idToken } } = { session: {} } }) => ({
    ...state,
    idToken: idToken && !hasTokenExpired(jwtDecode(idToken)) ?
      idToken :
      null
  }),
  [LOCATION_CHANGE]: ({ idToken, ...state }, { payload: { pathname } }) => ({
    ...(
      pathname === routes.newPassword ?
        state :
        initialState
    ),
    idToken
  })
};

export default handleActions(reducers, initialState);



// WEBPACK FOOTER //
// ./src/state/modules/session/reducers.js